import { render, staticRenderFns } from "./FeedFields.vue?vue&type=template&id=27664e20&scoped=true&"
import script from "./FeedFields.vue?vue&type=script&lang=js&"
export * from "./FeedFields.vue?vue&type=script&lang=js&"
import style0 from "./FeedFields.vue?vue&type=style&index=0&id=27664e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27664e20",
  null
  
)

export default component.exports